import { render, staticRenderFns } from "./NotificationTip.vue?vue&type=template&id=6bea4554"
import script from "./NotificationTip.vue?vue&type=script&lang=js"
export * from "./NotificationTip.vue?vue&type=script&lang=js"
import style0 from "./NotificationTip.vue?vue&type=style&index=0&id=6bea4554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports